module.exports = __webpack_public_path__ + "media/images/banner/awards_desktop-c4652713219e2a67e16a54f76ba20e97.jpg";